import React, { useState } from 'react';
import { fetchUsers, limpiarUsers, setearFiltros } from '../../../reducer/users-reducers';
import { connect } from 'react-redux';
import { user } from '../../../types/general-types';
import { Card, CardBody, CardTitle, Button, Input, CardHeader } from 'reactstrap';
import { filtros } from '../../../types/general-types';

interface configObject {
    usersReducer: {
        users: user[];
        filtros: filtros
    };
}

type userProps = {
    fetchUsers: (offset: number, apellido?: string, nombre?: string, idNumero?: string, email?: string) => void;
    users: user[],
    limpiarUsers: () => void,
    setearFiltros: (filtros: filtros | null) => void,
    filtros:filtros
}

type FiltrosType = {
    [key: string]: string;
  };

const UsersFilter = (props: userProps) => {
    const { fetchUsers, limpiarUsers, setearFiltros } = props;

    const [filtros, setFiltros] = useState<FiltrosType>({
        nombre: '',
        apellido: '',
        email: '',
        idNumero: '',
    });
    const [isFocused, setIsFocused] = useState(false);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFiltros((prevFiltros) => ({ ...prevFiltros, [name]: value }));
    };
    const transformPlaceholder = (placeholder:string) => {
        const camelCaseString = placeholder.replace(/\s+/g, '').replace(/ú/g, 'u');
        return camelCaseString === 'IDNumero' ? 'idNumero' : camelCaseString.toLowerCase();
      };

    const filtrarResultados = () => {
        limpiarUsers();
        fetchUsers(0, filtros.apellido, filtros.nombre, filtros.idNumero, filtros.email);
        setearFiltros(filtros);
    }

    const limpiarFiltros = () => {
        limpiarUsers();
        fetchUsers(0);
        setearFiltros(null);
        setFiltros({nombre:'', apellido: '', email: '', idNumero: ''})
    }

    const inputPlaceholders = ['Nombre', 'Apellido', 'Email', 'ID Número'];

    return (
        <Card className='mt-2 mb-2'>
            <CardHeader className='mt-0 d-flex justify-content-between'>
                <CardTitle tag="h5" className='text-start'>Filtros</CardTitle>
                {props.filtros && <Button onClick={limpiarFiltros}>Limpiar Filtros</Button>}
            </CardHeader>
            <CardBody id="filtros" className={isFocused ? 'parent-focused' : ''}>
                <div className='d-flex filtros'>
                    {inputPlaceholders.map((placeholder, index) => (
                        <Input
                            key={index}
                            type="text"
                            placeholder={placeholder}
                            name={transformPlaceholder(placeholder)}
                            value={filtros[transformPlaceholder(placeholder)]}
                            onChange={handleInputChange}
                            onFocus={()=>{setIsFocused(true)}}
                            onBlur={()=>{setIsFocused(false);}}
                            autoComplete='off'
                        />
                    ))}
                    <Button onClick={filtrarResultados}>Buscar</Button>
                </div>
            </CardBody>
        </Card>
    );
};


const mapStateToProps = (state: configObject) => {
    return {
        users: state.usersReducer.users,
        filtros: state.usersReducer.filtros
    };
};
export default connect(mapStateToProps, {
    fetchUsers, limpiarUsers, setearFiltros
})(UsersFilter);
